module.exports = "\n <zingchart-angular [config]=\"myConfiges\" [height]=\"300\"></zingchart-angular>"